import React, { useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { NavLink, useNavigate } from "react-router-dom";
import SideBarActiveIcon from "../../../assets/icons/SideBarActive.svg";
import { RiProfileLine } from "react-icons/ri";
import { HiOutlineUserGroup, HiOutlineUserCircle } from "react-icons/hi";
import { MdOutlineNotificationsActive } from "react-icons/md";
import { RiLogoutBoxLine, RiFolderSettingsLine } from "react-icons/ri";
import { useGlobalContext } from "../../../Contexts/GlobalContext";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { LuFileKey } from "react-icons/lu";
import { PiBracketsCurlyBold } from "react-icons/pi";
import { HiCode } from "react-icons/hi";
import { logOut } from "@mirats/mirats-auth";
const Sidebar = ({ children }) => {
  const navigate = useNavigate();
  const [collapse, setCollapse] = useState(false);
  const { setSnackbar } = useGlobalContext();
  const SideBarData = [
    {
      name: "My Profile",
      path: "/profile/my-profile",
      subPath: "my-profile",
      icon: <RiProfileLine size={23} />,
    },
    // {
    //   name: "My Account",
    //   path: "/profile/my-account",
    //   subPath: "my-account",
    //   icon: <HiOutlineUserCircle size={23} />,
    // },
    {
      name: "Finance",
      path: "/profile/finance",
      subPath: "finance",
      icon: <LiaFileInvoiceDollarSolid size={23} />,
    },
    {
      name: "Project Settings",
      path: "/profile/project-settings",
      subPath: "project-settings",
      icon: <RiFolderSettingsLine size={23} />,
    },
    {
      name: "Post Back Url",
      path: "/profile/post-back",
      subPath: "post-back",
      icon: <PiBracketsCurlyBold size={23} />,
    },
    {
      name: "Redirects & keys",
      path: "/profile/redirects-and-keys",
      subPath: "redirects-and-keys",
      icon: <LuFileKey size={23} />,
    },
    {
      name: "Developer",
      path: "/profile/developer",
      subPath: "developer",
      icon: <HiCode size={23} />,
    },
    {
      name: "My Notifications",
      path: "/profile/my-notification",
      subPath: "my-notification",
      icon: <MdOutlineNotificationsActive size={23} />,
    },

    {
      name: "Members",
      path: "/profile/my-member",
      subPath: "my-member",
      icon: <HiOutlineUserGroup size={23} />,
    },
  ];

  return (
    <div className="w-full flex" style={{ height: "calc(100vh - 64px)" }}>
      <div
        className={`${collapse ? "w-[72px]" : "w-[280px]"} transition-all ease-in duration-300 bg-white z-[20] border-r border-gray-200 relative shadow-sm`}
      >
        {/* Collapse Button */}
        <button
          className={`w-7 h-7 flex items-center justify-center rounded-full absolute top-6 right-[-14px] transition-all origin-center ease-in duration-300 cursor-pointer bg-[#0226BE] hover:bg-[#021ea8] shadow-lg z-10 ${
            collapse ? "rotate-[180deg]" : ""
          }`}
          onClick={(e) => setCollapse(!collapse)}
          aria-label={collapse ? "Expand sidebar" : "Collapse sidebar"}
        >
          <IoIosArrowBack color="white" size={18} />
        </button>
        
        {/* Sidebar Content */}
        <div className="w-full flex flex-col gap-1 mt-8 px-2 overflow-y-auto containerScroll h-[calc(100%-120px)]">
          {SideBarData?.map((data, ind) => {
            const isActive = window.location.pathname?.includes(data?.subPath);
            return (
              <button
                key={ind}
                className={`flex items-center transition-all ease-in duration-200 ${
                  collapse ? "justify-center" : "justify-start"
                } h-[44px] cursor-pointer group relative rounded-lg mx-1 ${
                  isActive ? "bg-blue-50" : "hover:bg-gray-50"
                }`}
                onClick={(e) => navigate(data?.path)}
                title={collapse ? data?.name : undefined}
              >
                {/* Active Indicator */}
                {isActive && !collapse && (
                  <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-[#0226BE] rounded-r-full"></div>
                )}
                
                <div
                  className={`flex items-center gap-3 flex-1 transition duration-200 rounded-lg px-3 py-2 ${
                    collapse
                      ? "w-10 h-10 justify-center"
                      : "w-full"
                  }`}
                >
                  <div
                    className={`transition-colors ${
                      isActive
                        ? "text-[#0226BE]"
                        : "text-gray-500 group-hover:text-[#0226BE]"
                    }`}
                  >
                    {data?.icon}
                  </div>
                  {!collapse && (
                    <span
                      className={`text-[14px] font-[500] transition-colors whitespace-nowrap ${
                        isActive
                          ? "text-[#0226BE] font-[600]"
                          : "text-gray-700 group-hover:text-[#0226BE]"
                      }`}
                    >
                      {data?.name}
                    </span>
                  )}
                </div>
              </button>
            );
          })}
        </div>
        
        {/* Logout Button */}
        <div
          className={`absolute bottom-0 left-0 right-0 border-t border-gray-200 bg-white p-2 ${
            collapse ? "px-2" : "px-3"
          }`}
        >
          <button
            className={`flex items-center gap-3 w-full h-[44px] cursor-pointer group rounded-lg px-3 py-2 text-red-600 hover:bg-red-50 transition-all duration-200 ${
              collapse ? "justify-center" : "justify-start"
            }`}
            onClick={logOut}
            title={collapse ? "Logout" : undefined}
          >
            <RiLogoutBoxLine size={20} className="text-red-600 flex-shrink-0" />
            {!collapse && (
              <span className="text-[14px] font-[500] whitespace-nowrap">
                Logout
              </span>
            )}
          </button>
        </div>
      </div>
      <div
        className="px-6 pt-3 transition-all duration-300 ease-in flex items-center justify-center overflow-y-auto containerScroll bg-gray-50"
        style={{
          width: collapse ? "calc(100% - 72px)" : "calc(100% - 280px)",
          height: "calc(100vh - 64px)",
        }}
      >
        <div className="w-full max-w-[1400px] h-full pt-8">{children}</div>
      </div>
    </div>
  );
};

export default Sidebar;
